import { IBrand } from "@/api/AppApi/services/home/interfaces/IBrands";
import NextImage from "../../lib/NextImage";
import { Link } from "../../lib/navigation/Link";

interface Props extends IBrand {}

const Brand: React.FC<Props> = (props) => {
  return (
    <div className="brand">
      <Link
        prefetch={false}
        href={`/brands/${props.slug || props.id}`}
        skipCheckingForLang
      >
        <div className="content">
          <div className="img-container">
            <NextImage
              src={
                props?.logo?.thumbnail_url ??
                props?.logo?.image_url ??
                props?.logo_url ??
                ""
              }
              alt={props.name}
              objectFit="contain"
              sizes="40px"
            />
          </div>
          {props.name.slice(0, 19) + (props?.name?.length > 19 ? "..." : "")}
        </div>
      </Link>
    </div>
  );
};

export default Brand;
